//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import { formatTime } from '../../components/helpers.js'
import { createFieldConfig } from '../../components/QSelectUtils.js'

import FilesField from '../../components/File/FilesField.vue'
import ReportFilesGroup from './ReportFilesGroup.js'
import { reportFiles } from './ReportFiles.js'

const TG_BOT_REQUEST_STATUSES = [{
  key: 'workCompleted',
  dialogName: 'Отправка сообщения об успешном выполнении',
  btnName: 'Отправить сообщение об успешном выполнении',
  btnColor: 'positive'
}, {
  key: 'fakeRequest',
  dialogName: 'Отправка сообщения о фейке',
  btnName: 'Отправить сообщение о фейке',
  btnColor: 'red'
}, {
  key: 'rejectedRequest',
  dialogName: 'Отказ от выполнения заявки',
  btnName: 'Отказ от выполнения заявки',
  btnColor: 'primary'
}]

export default {
  name: 'ReportCityMessengerBotSection',
  components: {
    FilesField
  },
  mixins: [reportFiles],
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      formatTime: formatTime,

      categoryConfig: {
        key: 'cityMessengerBot',
        name: 'Фото для бота'
      },

      // FILES_PROPERTY: 'cityMessengerBotImgFiles',
      FILES_PROPERTY: 'guiImgFiles',
      categories: [],
      category: null,

      allClosingComments: null,

      sizeImg: 140,
      mode: 'view' // view, edit
    }
  },
  computed: {
    isSuccessSend: function () {
      return this.report.isCityMessengerBotSuccessSend === true
    },
    readonly: function () {
      return this.isSuccessSend
    },
    sendAvailable: function () {
      return !this.readonly && this.category && this.category.size > 0
    },
    tgBotRequestStatuses: function () {
      return TG_BOT_REQUEST_STATUSES
    },
    tgBotRequestStatusesByKey: function () {
      const result = {}
      for (const statusConfig of TG_BOT_REQUEST_STATUSES) {
        result[statusConfig.key] = statusConfig
      }
      return result
    },
    bannerClass: function () {
      const status = this.report.cityMessengerBotRequestStatus
      if (status) {
        const statusConfig = this.tgBotRequestStatusesByKey[status.key]
        if (statusConfig) {
          return 'bg-' + statusConfig.btnColor + ' text-white'
        }
        // 'bg-positive text-white'
      }
      return 'bg-white text-black'
    }
  },
  watch: {
    readonly: function (value) {
      if (this.category) {
        this.category.readonly = value
      }
    }
  },
  created: function () {
    let categoryConfig
    if (this.report.documentsCategories && this.report.documentsCategories.length) {
      categoryConfig = this.report.documentsCategories.find(categoryConfig => categoryConfig.key === this.categoryConfig.key)
    }
    if (!categoryConfig) {
      categoryConfig = this.categoryConfig
    }
    const readonly = this.readonly
    const required = this.report.requiredPhotoCategories.includes(categoryConfig.key)
    const category = new ReportFilesGroup({ categoryKey: categoryConfig.key, title: categoryConfig.name.toUpperCase(), readonly: readonly, required: required })
    this.category = category
    this.categories.push(category)

    const filesGroupsContainer = this.report.filesGroupsContainers[this.FILES_PROPERTY]
    filesGroupsContainer.addFilesGroups(this.categories.slice())
    this.filesGroupsContainer = filesGroupsContainer

    const user = this.$store.getters.getUser
    this.categoriesMap = {}
    this.categories.forEach(filesGroup => {
      this.$set(filesGroup, 'mode', 'view')

      if (filesGroup.categoryKey !== 'video') {
        filesGroup.contentType = 'image'
      } else {
        filesGroup.contentType = 'video'
      }

      const self = this
      filesGroup.enrichmentFn = function (document) {
        const description = []
        if (!user.hasSystemRoleStrict('publicationRead') && !user.restrictedAccess) {
          if (document.time) {
            description.push({ name: `Время загрузки ${self.getContentTypeName(filesGroup)}`, value: formatTime(document.time) })
          }
          if (document.originalTime) {
            description.push({ name: `Оригинальное время создания ${self.getContentTypeName(filesGroup)}`, value: formatTime(document.originalTime) })
          }
          if (document.description && document.description.length) {
            description.push(...document.description)
          }
        }

        return {
          name: document.altName || document.name, // TODO FileDocument - name
          description: description
        }
      }

      this.categoriesMap[filesGroup.key] = filesGroup
    })

    if (this.report.documents) {
      const categoryDocuments = this.report.documents.filter(document => document.category === 'cityMessengerBot')
      this.pushFiles(categoryDocuments)
    }
  },
  mounted: function () {
  },
  methods: {
    getContentTypeName: function (filesGroup) {
      return filesGroup.contentType === 'image' ? 'фото' : 'видео'
    },

    validate: function (action) {
      return true
    },
    onUpdated: function () {
      this.$emit('updated')
    },

    onClickSendStatus: function (statusConfig) {
      this.getClosingComments(statusConfig.key)
        .then(comments => {
          this.$d_ask({
            callback: (data, action) => {
              if (action === 'yes') {
                this.sendStatus(statusConfig.key, data.comment.key)
              }
            },
            header: statusConfig.dialogName,
            propsConfig: {
              comment: {
                label: 'Типовой комментарий',
                type: 'object',
                searchConfig: createFieldConfig({ allRecordsFn: () => comments }),
                emitId: false,
                required: true,
                readonly: comments.length === 1,
                value: comments.length === 1 ? comments[0] : null
              }
            },
            buttons: [
              { key: 'yes', name: 'Подтвердить' },
              { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
            ]
          })
        })
    },
    sendStatus: async function (statusKey, commentKey) {
      await this.uploadFiles(false)

      this.$q.loading.show({
        message: 'Отправка сообщения в бот',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })

      const urlParams = new URLSearchParams()
      urlParams.set('id', this.report.id)
      urlParams.set('status', statusKey)
      if (commentKey) {
        urlParams.set('comment', commentKey)
      }

      await axiosGet({
        url: '/vis/citybotsender/sendStatus?' + urlParams.toString(),
        onSuccess: (response) => {
          const report = this.report
          const result = response.data
          const isCityMessengerBotSuccessSend = result.isCityMessengerBotSuccessSend
          if (isCityMessengerBotSuccessSend != null) {
            report.isCityMessengerBotSuccessSend = isCityMessengerBotSuccessSend
          }
          if (isCityMessengerBotSuccessSend) {
            if (result.cityMessengerBotSendTime) {
              report.cityMessengerBotSendTime = result.cityMessengerBotSendTime
            }
            if (result.cityMessengerBotRequestStatus) {
              report.cityMessengerBotRequestStatus = result.cityMessengerBotRequestStatus
            }
            if (result.cityMessengerBotClosingCommentText) {
              report.cityMessengerBotClosingCommentText = result.cityMessengerBotClosingCommentText
            }
            if (result.cityMessengerBotRequestId) {
              report.cityMessengerBotRequestId = result.cityMessengerBotRequestId
            }

            this.$q.notify({
              type: 'positive',
              message: 'Сообщение отправлено',
              progress: true,
              timeout: 3000
            })
          } else {
            this.$q.notify({
              type: 'negative',
              message: 'Сообщение не отправлено',
              progress: true,
              timeout: 8000
            })
          }

          return isCityMessengerBotSuccessSend
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка отправки сообщения' + (response.message ? ': ' + response.message : ''),
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(response.message))
        },
        msgTarget: this,
        throws: true
      }).finally(() => {
        this.$q.loading.hide()
      })
    },

    // saveReport: async function () {
    //   const report = this.report
    //   const reportManager = report._reportManager
    //   if (reportManager.hasChanges()) {
    //     try {
    //       await reportManager.saveChanges({ target: this })
    //     } catch (error) {
    //       throw new Error('Невозможно сохранить отчёт')
    //     } finally {
    //       this.$q.loading.hide()
    //     }
    //   }
    // },

    uploadFiles: async function (hideLoadingOnSuccess = true) {
      const report = this.report
      const reportManager = report._reportManager

      const containerKey = this.FILES_PROPERTY
      const categoryKey = this.categoryConfig.key
      const filesGroupsContainer = reportManager.getFilesGroupsContainer(containerKey)
      const filesGroup = filesGroupsContainer.getFilesGroup(categoryKey)

      if (filesGroup.hasChanges()) {
        this.$q.loading.show({
          message: 'Сохранение файлов для бота',
          messageColor: 'blue-11',
          spinnerColor: 'blue-11'
        })

        try {
          await filesGroup.uploadFiles({
            uploadConfig: this.report && this.report.photoUploadConfig || null,
            notify: true,
            progress: true,
            target: this
          })

          if (hideLoadingOnSuccess) {
            this.$q.loading.hide()
          }
        } catch (error) {
          this.$q.loading.hide()
          throw new Error('Ошибка сохранения фото для бота')
        }
      }
    },

    getClosingComments: function (statusKey) {
      const requestTypeId = this.request.requestTypeId

      return this.getAllClosingComments()
        .then(comments => {
          return comments.filter(comment => {
            if (!comment.requestStatuses || !comment.requestStatuses.includes(statusKey)) {
              return false
            }
            if (!comment.requestTypes || comment.requestTypes.find(requestType => requestType.id === requestTypeId) == null) {
              return false
            }
            return true
          })
        })
    },
    getAllClosingComments: function () {
      if (this.allClosingComments) {
        return Promise.resolve(this.allClosingComments)
      }

      const urlParams = new URLSearchParams()
      urlParams.set('type', 'defaultClosingCommentsCityBot')
      urlParams.set('params', JSON.stringify([
        {
          param: 'orderNumber',
          type: 'integer',
          action: 'any'
        },
        {
          param: 'commentText',
          type: 'string',
          action: 'any'
        },
        {
          param: 'requestStatuses',
          type: 'listvalue',
          action: 'any'
        },
        {
          param: 'requestTypes',
          type: 'objects',
          action: 'any'
        }
      ]))

      urlParams.set('paramsOperation', 'and')
      urlParams.set('sort', 'param.orderNumber')
      urlParams.set('dir', 'ASC')
      urlParams.set('limit', 100000)

      return axiosGet({
        url: '/service/obj/search?' + urlParams.toString(),
        onSuccess: response => {
          this.allClosingComments = response.data.result.map(serverItem => {
            return {
              id: serverItem.id,
              key: serverItem.key,
              name: serverItem.name,
              orderNumber: serverItem['param.orderNumber'] || 0,
              commentText: serverItem['param.commentText'] || null,
              requestStatuses: serverItem['param.requestStatuses'] || [],
              requestTypes: serverItem['param.requestTypes'] || []
            }
          })
          return this.allClosingComments
        },
        onFailure: 'Ошибка загрузки типовых комментариев',
        msgTarget: this
      })
    }
  }
}

